import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core'
import React from 'react'


export default function VendorChangeModal({ showModal, hideModal }) {
  return (
    <Dialog open={showModal} onClose={hideModal}>
      <DialogTitle>Vendor Change</DialogTitle>
			
      <DialogContent>
        <DialogContentText>
          Time sheet already has routes entered for the current vendor.
        </DialogContentText>
        <DialogContentText>
          You must clear the Route IDs if you want to change vendors.
        </DialogContentText>
      </DialogContent>
			
      <DialogActions>
        <Button onClick={hideModal} color="primary" autoFocus>Okay</Button>
      </DialogActions>
    </Dialog>
  )
}